class TimelineFeature extends HTMLElement {
  constructor() {
    super();

    this.cards = Array.from(this.querySelectorAll('[data-timeline-card]'));
    this.contents = Array.from(this.querySelectorAll('[data-timeline-content]'));
    this.backgrounds = Array.from(this.querySelectorAll('[data-timeline-background]'));
    this.cardsTrack = this.querySelector('[data-timeline-cards]');

    this.handleCardClick = this.handleCardClick.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
  }

  connectedCallback() {
    this.cards.forEach((card) => {
      card.addEventListener('click', this.handleCardClick);
    });

    document.addEventListener('shopify:block:select', this.handleBlockSelect);

    if (this.cards.length) {
      const selectedIndex = this.cards.findIndex((card) => card.classList.contains('is-selected'));
      this.select(selectedIndex >= 0 ? selectedIndex : 0, { scrollIntoView: false });
    }
  }

  disconnectedCallback() {
    this.cards.forEach((card) => {
      card.removeEventListener('click', this.handleCardClick);
    });

    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleCardClick(event) {
    const card = event.currentTarget;
    const index = Number.parseInt(card.dataset.index, 10);

    if (Number.isNaN(index)) {
      return;
    }

    this.select(index);
  }

  handleBlockSelect(event) {
    if (!this.contains(event.target)) {
      return;
    }

    const card = event.target.closest('[data-timeline-card]');

    if (!card) {
      return;
    }

    const index = Number.parseInt(card.dataset.index, 10);

    if (Number.isNaN(index)) {
      return;
    }

    this.select(index);
  }

  select(index, options = {}) {
    const settings = {
      scrollIntoView: true,
      ...options
    };

    this.cards.forEach((card, cardIndex) => {
      const isSelected = cardIndex === index;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      card.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.contents.forEach((content, contentIndex) => {
      const isSelected = contentIndex === index;
      content.classList.toggle('is-selected', isSelected);
      content.toggleAttribute('hidden', !isSelected);
      content.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
    });

    this.backgrounds.forEach((background, backgroundIndex) => {
      const isSelected = backgroundIndex === index;
      background.classList.toggle('is-selected', isSelected);
      background.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
    });

    if (!settings.scrollIntoView || !this.cardsTrack) {
      return;
    }

    const selectedCard = this.cards[index];

    if (!selectedCard || this.cardsTrack.scrollWidth <= this.cardsTrack.clientWidth) {
      return;
    }

    selectedCard.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }
}

if (!customElements.get('timeline-feature')) {
  customElements.define('timeline-feature', TimelineFeature);
}
